import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import React, { useEffect, useState } from "react";

/*****************fetch all users */
const fetchUsers = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/Users/GetUsers/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchUsers = (data) => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => fetchUsers(data),
    enabled: true,
  });
};
/**
 * The master list of assignable pages, `GET /api/RolePage/GetRolePages`.
 *
 * KEPT, BUT NO LONGER THE WAY TO READ IT. `Context/PageAccessContext` fetches
 * this list once and shares it with the sidebar, the route gate and the
 * assign-pages tree — so use `usePageAccess().rolePages`. Three callers reading
 * it three different ways is how the menu, the routes and the checkbox list
 * came to disagree in the first place.
 *
 * Left exported for a screen that genuinely needs its own copy.
 */
const fetchPages = async (data) => {
  return await axios.get(API_URL + `/api/RolePage/GetRolePages`, {
    headers: securityHeaders,
  });
};

export const useFetchPages = (data) => {
  return useQuery({
    queryKey: ["pages"],
    queryFn: () => fetchPages(data),
    enabled: true,
  });
};

/*****************add user */

const addUser = (values) => {
  return axios.post(API_URL + `/api/Users/CreateUser`, values, {
    headers: securityHeaders,
  });
};

export const useAddUser = () => {
  return useMutation(addUser);
};

/*****************add user 000 */

const deleteUser = (array) => {
  return axios.post(API_URL + `/api/Users/DeleteUser`, array, {
    headers: securityHeaders,
  });
};

export const useDeleteUser = () => {
  return useMutation(deleteUser);
};

/***********Export table users */
const exportTableUsers = async () => {
  return await axios.get(API_URL + "/api/Export/ExportUsers", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableUsers = () => {
  return useMutation(() => exportTableUsers());
};

const changePassword = (values) => {
  return axios.post(
    API_URL +
      `/api/Users/ResetForcePassword?UserId=${values.UserId}&password=${values.password}`,
  {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const useChangePassword = () => {
  return useMutation(changePassword);
};
